var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1825 1.70501C13.4169 0.948377 12.3839 0.524048 11.3075 0.524048C10.2311 0.524048 9.19809 0.948377 8.43249 1.70501L7.99999 2.12751L7.57499 1.70501C6.80154 0.99834 5.78537 0.617144 4.73796 0.64076C3.69056 0.664376 2.6926 1.09098 1.95178 1.8318C1.21096 2.57262 0.784356 3.57058 0.76074 4.61798C0.737124 5.66539 1.11832 6.68156 1.82499 7.45501L7.73499 13.38C7.80563 13.4496 7.90082 13.4887 7.99999 13.4887C8.09917 13.4887 8.19436 13.4496 8.26499 13.38L14.1825 7.46251C14.9414 6.6966 15.3672 5.66199 15.3672 4.58376C15.3672 3.50554 14.9414 2.47093 14.1825 1.70501Z",
    fill: "#FF000F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d88caebe32ad99a4a1890f8fae52e4e5.svg";
export { ForwardRef as ReactComponent };